import React, {
  useEffect,
  useState,
  useRef,
  Suspense,
  useCallback,
} from "react";
import { connectApp } from "./store/app.connect";
import BetPlacingPopover from "./components/BetPlacingPopover/BetPlacingPopover";
import {
  clearIntervalAsync,
  setIntervalAsync,
} from "set-interval-async/dynamic";
import {
  GET_BALANCE_INTERVAL,
  ID_TOKEN,
  TOKEN_EXP,
  USER_DATA,
} from "./config/app.config";
import { BetPopoverContext } from "./context";
import {
  BASE_DEV_URL,
  BASE_URL,
  CONFIG,
  ENCRYPTION_KEY,
  IS_B2C,
  IS_NEW_DEPOSIT_WITHDRAWAL,
} from "./config/api.config";
import LeftSideMenuDesktop from "./components/LeftSideMenuDesktop/LeftSideMenuDesktop";
import MultiTabSessionGuard from "./components/MultiTabSessionGuard";
import {
  BrowserRouter,
  Navigate,
  Route,
  Router,
  Routes,
  useLocation,
} from "react-router-dom";
import ToolbarDesktop from "./components/ToolbarDesktop/ToolbarDesktop";
import FooterDesktop from "./components/FooterDesktop/FooterDesktop";
import LoginPopUp from "./components/LoginPopUp";
import "./App.css";
import BetInfoPanel from "./components/BetInfoPanel/BetInfoPanel";
import { useSelector, useDispatch } from "react-redux";
import { pagesInfoMapper } from "./helpers/pagesinfoMapper.helper";
import RootLoader from "./components/RootLoader/RootLoader";
import RulesPopUpSportEvents from "./components/Rules/RulesPopUpSportEvents";
import ComingSoonPopup from "./components/comingSoonPopup/ComingSoon";
import CashoutPopup from "./components/CashoutPopup/CashoutPopup";
import BottomDepositBar from "./components/BottomDepositBar/BottomDepositBar";
import WhatsappPortal from "./components/WhatsappPortal/WhatsappPortal";
import SlotsCasinoPopUp from "./components/SlotsCasinoPopup";
import TableCasinoLive from "./pages/CasinoLive/TableCasinoLive";
import RacingPage from "./pages/RacingPage/RacingPage";
import LanguagePopUp from "./components/LanguagePopUp";
import SVG_RedBell from "./assets/images/svgs/bellRed.svg?react";
import AffiliateLayout from "./pages/Affiliate/AffiliateLayout";
import { setAffCode } from "./store/signUp/signUp.slice";
import BettingProfitLoss from "./pages/Affiliate/BettingProfitLoss";
import PopupImage from "./components/PopupImage/PopupImage";
import axios from "axios";
import { fetchConversionRate } from "./store/casinoConversion/casinoConversion.slice";
import CasinoConversion from "./components/CasinoConversion";

import CryptoJS from "crypto-js";
import { setTab } from "./store/LoginNew/loginNew.slice";
import { requestAuth } from "./store/auth/auth.thunks";

const DefaultPage = React.lazy(() => import("./pages/DefaultPage/DefaultPage"));
const SportsPage = React.lazy(() => import("./pages/SportsPage/SportsPage"));
const EventPage = React.lazy(() => import("./pages/EventPage/EventPage"));
const IndianCardGamePage = React.lazy(
  () => import("./pages/IndianCardGamePage/IndianCardGamePage"),
);
const MyOpenBets = React.lazy(() => import("./pages/MyOpenBets/MyOpenBets"));
const CompletitionDetailPage = React.lazy(
  () => import("./pages/CompetitionDetailPage/CompletitionDetailPage"),
);
const RulesRegs = React.lazy(() => import("./pages/RulesRegs/RulesRegs"));
const ExclusionPolicy = React.lazy(() => import("./pages/ExclusionPolicy"));
const ResponsibleGambling = React.lazy(
  () => import("./pages/ResponsibleGambling"),
);
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy"));
const ChangePassword = React.lazy(
  () => import("./pages/ChangePassword/ChangePassword"),
);
const Settings = React.lazy(() => import("./pages/Settings/Settings"));
const TimeSettings = React.lazy(
  () => import("./pages/TimeSettings/TimeSettings"),
);
const CasinoLobby = React.lazy(() => import("./pages/CasinoLobby/CasinoLobby"));
const CasinoLive = React.lazy(() => import("./pages/CasinoLive/CasinoLive"));
const GapLiveCasino = React.lazy(
  () => import("./pages/CasinoLive/GapLiveCasino"),
);
const Transactions = React.lazy(
  () => import("./pages/Transactions/Transactions"),
);
const TransactionDetails = React.lazy(
  () => import("./pages/TransactionDetails/TransactionDetails"),
);
const Deposit = React.lazy(
  () =>
    import(
      IS_NEW_DEPOSIT_WITHDRAWAL
        ? "./pages/Deposit/Deposit"
        : "./pages/DepositOld/Deposit"
    ),
);
const Withdrawal = React.lazy(
  () =>
    import(
      IS_NEW_DEPOSIT_WITHDRAWAL
        ? "./pages/Withdrawal/Withdrawal"
        : "./pages/WithdrawalOld/Withdrawal"
    ),
);
const BettingProfitAndLossPage = React.lazy(
  () => import("./pages/BettingProfitAndLossPage/BettingProfitAndLossPage"),
);
const BettingProfitAndLossDetailsPage = React.lazy(
  () =>
    import("./pages/BettingProfitAndLoseDetailsPage/BettingProfitAndLossDetailsPage"),
);
const AccountStatementPage = React.lazy(
  () => import("./pages/AccountStatementPage/AccountStatementPage"),
);
const ReferCode = React.lazy(() => import("./pages/ReferCode/ReferCode"));
const AccountStatementDetailsPage = React.lazy(
  () =>
    import("./pages/AccountStatementDetailsPage/AccountStatementDetailsPage"),
);
const TransferStatementPage = React.lazy(
  () => import("./pages/TransferStatementPage/TransferStatementPage"),
);
const AviatorPage = React.lazy(() => import("./pages/AviatorPage/AviatorPage"));
const ElectionPage = React.lazy(() => import("./pages/Election/ElectionPage"));
const CasinoAura = React.lazy(() => import("./pages/CasinoLive/CasinoAura"));
const LotusCasinoLive = React.lazy(
  () => import("./pages/CasinoLive/LotusCasinoLive"),
);
const Bonus = React.lazy(() => import("./pages/Bonus/Bonus"));
const BonusStatementPage = React.lazy(
  () => import("./pages/BonusStatement/BonusStatement"),
);
const BonusRules = React.lazy(() => import("./pages/BonusRules/BonusRules"));

const Affiliate = React.lazy(() => import("./pages/Affiliate/Affiliate"));
const AffilateUserList = React.lazy(
  () => import("./pages/Affiliate/AffilateUserList"),
);
const UserProfitLoss = React.lazy(
  () => import("./pages/Affiliate/UserProfitLoss"),
);
const AffiliateReport = React.lazy(
  () => import("./pages/Affiliate/AffiliateReport"),
);

function App({
  actions,
  auth,
  user,
  balance,
  showBetPlacingPopover,
  showCashoutPopup,
  lastActivityDate,
  loginNew,
  rulesPopUp,
  language,
}) {
  const location = useLocation();
  const [scrollPosition, setScrollPosition] = useState(0);
  const refBetPopover = useRef(null);
  const [pageInfo, setPageInfo] = useState(null);
  const [localPathnameNow, setLocalPathnameNow] = useState();
  const [isHovered, setIsHovered] = useState(false);
  const [isOpened, setIsOpened] = useState(false);
  const [openPopup, setOpenPopUp] = useState(false);
  const bellRef = useRef(null);
  const width = window.innerWidth;

  useEffect(() => {
    const currentUrl = window.location.href;
    if (currentUrl) {
      const url = new URL(currentUrl);
      const referCode = url.searchParams.get("ReferBy");
      const affCode = url?.searchParams.get("af_code");
      const isAuth = localStorage.getItem(`${ID_TOKEN}`);

      if (!isAuth && (referCode || affCode)) {
        setTimeout(() => {
          actions.setReferCode(referCode);
          actions.setLoginNew(true);
          actions.setAffCode(affCode);
          actions.setTab(2);
        }, 500);
      }
    }
  }, [auth]);

  useEffect(() => {
    actions.requestStakeButtons();

    if (auth !== undefined) {
      actions.requestMenu();
    }

    if (auth) {
      const hasSeenPopup = localStorage.getItem("hasSeenLoginPopup");

      if (!hasSeenPopup) {
        setOpenPopUp(true);
        localStorage.setItem("hasSeenLoginPopup", "true");
      }
    }
  }, [auth]);

  const handleLogOut = (...args) => {
    // actions
    actions.requestLogout();
  };

  useEffect(() => {
    try {
      const localToken = localStorage.getItem(`${ID_TOKEN}`);
      const localTokenExp = localStorage.getItem(`${TOKEN_EXP}`);
      const localUser = localStorage.getItem(`${USER_DATA}`);
      // If app has been F5ed  - get all app data again
      // Otherwise log user out
      if (localToken && localUser && localTokenExp) {
        actions.getAuthSuccess(localToken);
        actions.setUserDataSuccess(JSON.parse(localUser));
        actions.setAuthDataSuccess({ payload: { exp: localTokenExp } });
      }
    } catch (error) {
      actions.requestLogout();
    }

    actions.setBannerPopUp(true);
  }, []);

  useEffect(() => {
    if (typeof document === "undefined") return;

    try {
      const head = document.head;
      if (!head) return;

      // ---- META DESCRIPTION ----
      let meta = head.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        head.appendChild(meta);
      }
      meta.content = CONFIG.metaDescription;

      // ---- TITLE ----
      if (CONFIG.title) {
        document.title = CONFIG.title;
      }

      // ---- APPLE TOUCH ICON ----
      let appleTouchIcon = head.querySelector('link[rel="apple-touch-icon"]');
      if (!appleTouchIcon) {
        appleTouchIcon = document.createElement("link");
        appleTouchIcon.rel = "apple-touch-icon";
        head.appendChild(appleTouchIcon);
      }
      appleTouchIcon.href = CONFIG.appleTouchIcon;

      // ---- MANIFEST ----
      let manifest = head.querySelector('link[rel="manifest"]');
      if (!manifest) {
        manifest = document.createElement("link");
        manifest.rel = "manifest";
        head.appendChild(manifest);
      }
      manifest.href = CONFIG.manifestUrl;

      // ---- VARIABLE CSS ----
      if (CONFIG.variableCss) {
        let themeLink = head.querySelector('link[data-theme="variable-css"]');

        if (!themeLink) {
          themeLink = document.createElement("link");
          themeLink.rel = "stylesheet";
          themeLink.setAttribute("data-theme", "variable-css");
          head.appendChild(themeLink);
        }

        themeLink.href = CONFIG.variableCss;
      }
    } catch (e) {
      console.error(e);
    }
  }, [CONFIG]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (bellRef.current && !bellRef.current.contains(event.target)) {
        setIsOpened(false);
      }
    }

    if (isOpened) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpened]);

  const getBalance = () => {
    actions.requestBalance().catch((e) => console.log("balance error = ", e));
  };

  const getDomainWithoutSubdomain = (url) => {
    try {
      const urlParts = new URL(url).hostname.split(".");
      return urlParts
        .slice(0)
        .slice(-(urlParts.length === 4 ? 3 : 2))
        .join(".");
    } catch (error) {
      console.log("55", error);
      return "";
    }
  };

  useEffect(() => {
    // const domainName = window.location.origin;
    const domainName = BASE_URL;
    const domainData = getDomainWithoutSubdomain(domainName);

    const data = {
      key: btoa(domainData),
    };

    actions.requestLogo(data);
  }, []);

  useEffect(() => {
    if (auth) {
      getBalance();
      const timer = setIntervalAsync(async () => {
        await actions
          .requestBalance()
          .catch((e) => console.log("balance error = ", e));
      }, 5000);
      return () => clearIntervalAsync(timer);
    }
  }, [auth]);

  useEffect(() => {
    if (auth) actions.requestOpenBets();
  }, [lastActivityDate, auth]);

  useEffect(() => {
    const segmant = location.pathname.split("/");
    const required = pagesInfoMapper[segmant[1]];
    if (!!required) {
      setPageInfo(required);
    } else {
      setPageInfo(pagesInfoMapper["default-page"]);
    }

    const queryParams = new URLSearchParams(location.search);
    const referCode = queryParams.get("referCode");

    if (referCode) {
      actions.setLoginNew(true);
      actions.setTab(2);
    }

    // console.log("location: ", referCode);
  }, [location]);

  const handleEventTypeSuccess = (...args) => {
    if (!!args[0] && args[0]?.success) {
      actions.requestLogout();
    }
  };

  const cancelBetPopover = () => {
    if (refBetPopover.current) {
      refBetPopover.current.dismiss();
    }
    setTimeout(() => {
      if (refBetPopover.current) {
        refBetPopover.current.dismiss();
      } else {
        actions.setShowBetPlacingPopover(false);
      }
    }, 100);
  };

  // useEffect(() => {
  //   setRenderFooter(true);
  // }, [location]);

  const desktopWithOnlyMainContainer =
    location.pathname === "/indian-card-games" ||
    location.pathname.includes("casino-lobby") ||
    location.pathname.includes("casino-live") ||
    location.pathname.includes("table-casino-live") ||
    location.pathname.includes("aviator") ||
    location.pathname.includes("livegames") ||
    location.pathname.includes("indian-casino") ||
    location.pathname.includes("affiliate");

  const renderHeader = useCallback(() => {
    return width < 1024
      ? !location.pathname.includes("casino-live") &&
          !location.pathname.includes("table-casino-live") &&
          !location.pathname.includes("livegames")
      : true;
  }, [width, location.pathname]);

  const renderFooter = useCallback(() => {
    return (
      location.pathname === "/" || location.pathname.includes("default-page")
    );
    return width < 1024
      ? location.pathname === "/"
      : !location.pathname.includes("casino-live") &&
          !location.pathname.includes("table-casino-live") &&
          !location.pathname.includes("livegames") &&
          !location.pathname.includes("casino-lobby") &&
          !location.pathname.includes("event-page") &&
          !location.pathname.includes("affiliate");
  }, [width, location.pathname]);

  const googleTranslateElementInit = () => {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: "en",
        autoDisplay: false,
      },
      "google_translate_element",
    );
  };

  // Load Google Translate script
  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined")
      return;
    const addScript = document.createElement("script");
    addScript.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    document.body.appendChild(addScript);
    window.googleTranslateElementInit = googleTranslateElementInit;

    // Remove unwanted elements after load
    setTimeout(() => {
      document.querySelectorAll("iframe").forEach((iframe) => {
        if (iframe.id.startsWith(":")) {
          iframe.style.display = "none";
        }
      });
    }, 1000); // Wait for iframe to load before hiding
  }, []);

  // Direct language change
  const changeLanguage = (lang) => {
    if (!window.google || !window.google.translate) {
      return;
    }

    // Set language directly
    const select = document.querySelector(".goog-te-combo");
    if (select) {
      select.value = lang; // Set language code
      select.dispatchEvent(new Event("change"));
    }
  };

  useEffect(() => {
    setTimeout(() => {
      changeLanguage(language);
    }, 2000);
  }, [language]);

  useEffect(() => {
    const target = document.getElementById("otpless-login-page");

    if (!target) return;

    const observer = new MutationObserver(() => {
      if (target.children.length > 0) {
        target.classList.add("otpless-visible");
      } else {
        target.classList.remove("otpless-visible");
      }
    });

    observer.observe(target, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || typeof document === "undefined")
      return;
    const interval = setInterval(() => {
      const container = document.getElementById("otpless-login-page");
      if (container) {
        clearInterval(interval);

        const addCloseButton = () => {
          if (document.getElementById("custom-close-btn")) return;

          const closeBtn = document.createElement("div");
          closeBtn.id = "custom-close-btn";
          closeBtn.innerText = "×";
          closeBtn.style.cssText = `
            position: absolute;
            top: 10px;
            right: 10px;
            width: 30px;
            height: 30px;
            background-color: #ff4d4f;
            color: #fff;
            font-size: 22px;
            font-weight: bold;
            border-radius: 50%;
            text-align: center;
            line-height: 30px;
            cursor: pointer;
            z-index: 99999999;
          `;

          closeBtn.onclick = () => {
            const iframe = container.querySelector("iframe");
            if (iframe) container.removeChild(iframe);

            container.innerHTML = "";
            container.removeAttribute("style");

            const parentDiv = document.getElementById(
              "otpless-login-page-parent",
            );
            if (parentDiv) {
              parentDiv.remove();
            }
          };

          container.appendChild(closeBtn);
        };

        const observer = new MutationObserver(() => {
          if (container.classList.contains("otpless-visible")) {
            addCloseButton();
          }
        });

        observer.observe(container, {
          attributes: true,
          attributeFilter: ["class"],
        });
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (code) {
      const otplessInit = Reflect.get(window, "otplessInit");
      otplessInit?.();
    }
  }, []);

  const promotions = useSelector((state) => state.promotions.socials);

  const isAffiliate = location.pathname.includes("affiliate");
  const token = localStorage.getItem("id_token");
  const [imgData, setImgData] = useState({});
  useEffect(() => {
    const fetchAuraData = async () => {
      try {
        const response = await axios.get(
          `${BASE_DEV_URL}content/popContentGet?content_type=Popup&host=${window.location.hostname}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response?.data) {
          setImgData(response?.data?.data);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (auth) {
      fetchAuraData();
    }
  }, [auth, token]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (auth) {
      dispatch(fetchConversionRate());
    }
  }, [auth]);

  const [hideNews, setHideNews] = useState(true);

  const { pathname } = useLocation();

  const [data, setData] = useState(null);

  const decryptData = (encryptedText) => {
    try {
      const decoded = decodeURIComponent(encryptedText);
      const bytes = CryptoJS.AES.decrypt(decoded, ENCRYPTION_KEY);
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedText) {
        console.error("Decryption failed");
        return null;
      }

      return decryptedText;
    } catch (err) {
      console.error("Error:", err);
      return null;
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const u = params.get("u");
    const p = params.get("p");
    const t = params.get("t");

    if (!u || !p) {
      console.log("No data found in URL");
      return;
    }

    const username = decryptData(u);
    const password = decryptData(p);

    setData({
      username,
      password,
      timestamp: t,
    });
  }, []);

  useEffect(() => {
    if (data?.username && data?.password && !auth) {
      const payload = {
        user_name: data?.username,
        password: data?.password,
        grant_type: "password",
      };
      dispatch(requestAuth(payload));
    }
  }, [data, auth]);

  return (
    <>
      <MultiTabSessionGuard />
      {openPopup && imgData && (
        <PopupImage setOpen={setOpenPopUp} auth={auth} imgData={imgData} />
      )}
      <CasinoConversion />
      <div id="google_translate_element" style={{ display: "none" }}></div>
      <div
        // ref={appRef}
        // onScroll={() => {
        //   setScrollPosition(appRef?.current?.scrollTop);
        //   actions.scrollPositionThunk(appRef?.current?.scrollTop);
        // }}
        className="w-full flex flex-col app-bg h-[100dvh] overflow-x-hidden overflow-y-auto"
      >
        <BetPopoverContext.Provider value={cancelBetPopover}>
          {renderHeader() && (
            <ToolbarDesktop setHideNews={setHideNews} hideNews={hideNews} />
          )}
          {/* <div className="flex flex-col  transition-all lg:pt-[110px] ease-in-out duration-100 pt-[94px]"> */}
          <div
            className={`flex flex-col  transition-all ${
              hideNews && auth ? "lg:pt-[143px]" : "lg:pt-[110px]"
            } ease-in-out duration-100 ${
              hideNews &&
              auth &&
              !pathname?.includes("event-page") &&
              !pathname?.includes("deposit") &&
              !pathname?.includes("livegames") &&
              !pathname?.includes("casino-live") &&
              !pathname?.includes("gapcasino-live")
                ? "pt-[120px]"
                : pageInfo?.containerClass
            }`}
          >
            <div
              className={`flex items-start ${
                isAffiliate ? "justify-center " : "justify-start"
              } w-full ${
                !desktopWithOnlyMainContainer
                  ? "lg:px-12 xl:px-20 xlg:px-24"
                  : ""
              }`}
            >
              {!desktopWithOnlyMainContainer && <LeftSideMenuDesktop />}

              <Suspense fallback={<RootLoader />}>
                <Routes>
                  <Route
                    path="/"
                    element={
                      <DefaultPage localPathnameNow={localPathnameNow} />
                    }
                  />
                  <Route
                    path="/default-page"
                    element={
                      <DefaultPage localPathnameNow={localPathnameNow} />
                    }
                  />

                  <Route
                    path="/sports-page/:sportsName/:eventTypeId"
                    element={<SportsPage localPathnameNow={localPathnameNow} />}
                  />

                  <Route
                    path="/competition-detail-page/:competitionName/:eventTypeId/:competitionId"
                    element={
                      <CompletitionDetailPage
                        localPathnameNow={localPathnameNow}
                      />
                    }
                  />

                  <Route
                    path="/event-page/:eventTypeId/:eventId/:marketId?"
                    element={<EventPage />}
                  />

                  <Route
                    path="/indian-card-games"
                    element={<IndianCardGamePage />}
                  />

                  <Route path="/open-bets" element={<MyOpenBets />} />

                  <Route path="rules-regulations" element={<RulesRegs />} />
                  <Route path="bonus-rules" element={<BonusRules />} />
                  <Route
                    path="exclusion-policy"
                    element={<ExclusionPolicy />}
                  />
                  <Route
                    path="responsible-gambling"
                    element={<ResponsibleGambling />}
                  />
                  <Route path="privacy-policy" element={<PrivacyPolicy />} />

                  <Route path="change-password" element={<ChangePassword />} />

                  <Route path="settings" element={<Settings />} />

                  <Route path="time-setting" element={<TimeSettings />} />

                  <Route path="casino-lobby/*" element={<CasinoLobby />} />
                  <Route path="/" element={<AffiliateLayout />}>
                    <Route path="affiliate" element={<Affiliate />} />
                    <Route
                      path="affiliate/user-list"
                      element={<AffilateUserList />}
                    />
                    <Route
                      path="affiliate/profit-loss/:id?"
                      element={<BettingProfitLoss />}
                    />
                    <Route
                      path="affiliate/user-profit-loss"
                      element={<UserProfitLoss />}
                    />
                    <Route
                      path="affiliate/report"
                      element={<AffiliateReport />}
                    />
                  </Route>

                  <Route
                    path="casino-live/:gameId/:tableId"
                    element={<CasinoLive />}
                  />
                  <Route
                    path="gapcasino-live/:gameId/:tableId/:provider"
                    element={<GapLiveCasino />}
                  />
                  <Route
                    path="table-casino-live/:eventName"
                    element={<TableCasinoLive />}
                  />

                  <Route path="transactions" element={<Transactions />} />

                  <Route
                    path="transactions-details/:type/:refrenceNo"
                    element={<TransactionDetails />}
                  />

                  {/* {(CONFIG.showDeposit)&& */}
                  <Route path="/deposit" element={<Deposit />} />
                  {/* } */}

                  {IS_B2C && (
                    <Route path="/withdraw" element={<Withdrawal />} />
                  )}

                  <Route
                    path="/betting-profit-loss"
                    element={<BettingProfitAndLossPage />}
                  />
                  <Route
                    path="/betting-profit-loss-details"
                    element={<BettingProfitAndLossDetailsPage />}
                  />

                  <Route
                    path="/account-statement/:id?/:type?"
                    element={<AccountStatementPage />}
                  />
                  <Route path="/refer-earn" element={<ReferCode />} />
                  <Route
                    path="/account-statement-details"
                    element={<AccountStatementDetailsPage />}
                  />

                  <Route
                    path="/transfer-statement"
                    element={<TransferStatementPage />}
                  />

                  <Route path="/aviator" element={<AviatorPage />} />

                  <Route
                    path="/ReferBy/:referCode"
                    element={<Navigate to="/" replace />}
                  />

                  <Route
                    path="/horse-racing"
                    element={<RacingPage localPathnameNow={localPathnameNow} />}
                  />

                  <Route
                    path="/greyhound-racing"
                    element={<RacingPage localPathnameNow={localPathnameNow} />}
                  />

                  <Route path="/election" element={<ElectionPage />} />

                  <Route
                    path="livegames/:gameId?/:tableId?/:marketId?"
                    element={<CasinoAura />}
                  />
                  <Route
                    path="indian-casino/:gameId/:inplay?"
                    element={<LotusCasinoLive />}
                  />

                  <Route
                    path="/bonuses"
                    element={<Bonus localPathnameNow={localPathnameNow} />}
                  />

                  <Route
                    path="/bonus-statement"
                    element={
                      <BonusStatementPage localPathnameNow={localPathnameNow} />
                    }
                  />

                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Suspense>

              {width >= 1024 && !desktopWithOnlyMainContainer && (
                <BetInfoPanel />
              )}
            </div>
          </div>
        </BetPopoverContext.Provider>

        {width < 1024 &&
          IS_B2C &&
          (location.pathname.includes("casino-live") ||
            location.pathname.includes("aviator") ||
            location.pathname.includes("table-casino-live") ||
            location.pathname.includes("livegames")) && <BottomDepositBar />}

        {location.pathname == "/" &&
          IS_B2C &&
          promotions?.Whatsapp?.is_active && <WhatsappPortal />}

        {renderFooter() && <FooterDesktop />}

        <LoginPopUp
          open={loginNew.open}
          onDidDismiss={() => {
            actions.setLoginNew(false);
          }}
          data={data}
        />

        <LanguagePopUp
          open={loginNew.isLanguage}
          onDidDismiss={() => {
            actions.setIsLangauage(false);
          }}
        />

        <RulesPopUpSportEvents
          open={rulesPopUp}
          // onDidDismiss={closeRuleRegulationPopup}
          scrollPosition={scrollPosition}
        />

        {width < 1024 && showBetPlacingPopover && (
          <BetPlacingPopover
            cancel={cancelBetPopover}
            refBetPopover={refBetPopover}
            open={showBetPlacingPopover}
          />
        )}

        <ComingSoonPopup />
        {showCashoutPopup && <CashoutPopup />}

        <SlotsCasinoPopUp />
        {/* {width < 1024 && showBetPlacingPopover ? (
          <BetPlacingPopover
            cancel={cancelBetPopover}
            refBetPopover={refBetPopover}
            open={showBetPlacingPopover}
          />
        ) : (
          <ConfirmBetPopUp
            cancel={cancelBetPopover}
            refBetPopover={refBetPopover}
            open={showBetPlacingPopover}
          />
        )} */}

        {/* <BetPopoverContext.Provider value={cancelBetPopover}>
          <BrowserRouter history={history}>

            <div className="flex flex-col  transition-all lg:pt-[110px] ease-in-out duration-100 pt-[94px]">
              <Routes>
                <Route
                  exact
                  path="/default-page"
                  render={() =>
                    authRender(
                      <DefaultPage localPathnameNow={localPathnameNow} />
                    )
                  }
                />
                <Redirect to="/default-page" />
              </Routes>
            </div>
          </BrowserRouter>
        </BetPopoverContext.Provider> */}
      </div>

      {/* <div
        id="onesignal-bell-container"
        className="onesignal-bell-container onesignal-reset onesignal-bell-container-bottom-right"
      >
        <div
          ref={bellRef}
          id="onesignal-bell-launcher"
          className={`
            onesignal-bell-launcher 
            onesignal-bell-launcher-bottom-right 
            onesignal-bell-launcher-theme-default 
            onesignal-bell-launcher-active 
            onesignal-bell-launcher-${isHovered || isOpened ? "" : "in"}active 
            ${
              isHovered || isOpened
                ? "onesignal-bell-launcher-md"
                : "onesignal-bell-launcher-sm"
            }`}
          style={{ bottom: 20, right: 14 }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={() => setIsOpened(true)}
        >
          <div className="onesignal-bell-launcher-button">
            <SVG_RedBell />
            <div
              className="pulse-ring"
              style={{ borderColor: "var(--icon-color-secondary)" }}
            ></div>
          </div>
          <div
            className="onesignal-bell-launcher-badge"
            style={{
              background: "var(--icon-color-brand-primary",
              borderColor: "var(--icon-color-brand-primary)",
              color: "var(--icon-color-secondary)",
            }}
          ></div>
          <div
            className={`onesignal-bell-launcher-message ${
              isHovered && !isOpened && "onesignal-bell-launcher-message-opened"
            }`}
          >
            <div className="onesignal-bell-launcher-message-body">
              You've blocked notifications
            </div>
          </div>
          <div
            className={`onesignal-bell-launcher-dialog ${
              isOpened && "onesignal-bell-launcher-dialog-opened"
            }`}
            style={{
              filter: "drop-shadow(0px 2px 2px rgba(34, 36, 38, 0.15))",
              WebkitFilter: "drop-shadow(0px 2px 2px rgba(34, 36, 38, 0.15))",
            }}
          >
            <div className="onesignal-bell-launcher-dialog-body">
              <h1>Unblock Notifications</h1>
              <div className="divider"></div>
              <div className="instructions">
                <p>Follow these instructions to allow notifications:</p>
                <a
                  href="https://media.onesignal.com/web-sdk/bell/chrome-unblock.jpg"
                  target="_blank"
                >
                  <img src="https://media.onesignal.com/web-sdk/bell/chrome-unblock.jpg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div id="otpless-login-page"></div>
    </>
  );
}

export default connectApp()(App);
